import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

interface IdashBoardGraph {
  aggregatorId?: number;
  filter?: number;
}
const getDashboardBorrowersGraph = async ({
  aggregatorId,
  filter,
}: IdashBoardGraph) => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.DASHBOARD_BORROWER_GRAPH}?aggregatorId=${aggregatorId}&filter=${filter}`
  );
  return data;
};

export default function useDashboardBorrowerGraph({
  aggregatorId,
  filter,
}: IdashBoardGraph) {
  return useQuery(
    [{ aggregatorId, filter }, "getDashboardBorrowersGraph"],
    getDashboardBorrowersGraph,
    {
      refetchOnWindowFocus: false,
      enabled: aggregatorId ? true : false,
      cacheTime: 1000,
    }
  );
}
